<template>
  <div>
    <user-center-header></user-center-header>
    <div class="container-fluid section">
      <left-sidebar class="side-bar" :class="{'open': isOpen}"></left-sidebar>
      <div class="container-fluid user-center-content">
        <router-view></router-view>
      </div>
    </div>
    <plex-footer class="phone-show"></plex-footer>
  </div>
</template>

<script>
  import LeftSidebar from '../../components/leftSidebar/Index.vue'
  import UserCenterHeader from '../../components/plexHeader/userCenterHeader/Index.vue'
  import PlexFooter from '../../components/footer/Footer.vue'

  export default {
    name: 'user-center-main',
    data: function () {
      return {
        isOpen: true
      }
    },
    computed: {
      isOpenLeftSidebar() {
        return this.$store.state.isOpenLeftSidebar
      }
    },
    watch: {
      isOpenLeftSidebar: function (val) {
        this.isOpen = val
      },
      isOpen: function (value) {
        if (!value) {
          this.$store.commit('setIsOpenLeftSidebar', false)
        }
      }
    },
    components: {
      LeftSidebar,
      UserCenterHeader,
      PlexFooter
    },
    beforeCreate() {
      if (this.$route.query.utm_campaign) {
        window.sessionStorage.setItem('utmCampaign', this.$route.query.utm_campaign)
      }
    },
    created() {
      this.$store.commit('isSpecialHeader', true)
    },
  }
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  @import "../../assets/scss/variables";

  * {
    padding: 0;
    margin: 0;
  }

  .section {
    margin: 0;
    background-color: #fff;
    @media screen and (min-width: 768px) {
      min-height: 100vh;
    }
  }

  .user-center-content {
    padding: .24rem;
    background: #fff;
  }

  .phone-show {
    display: none;
  }

  @mixin phone-style() {
    .phone-show {
      display: block;
    }
  }

  @mixin pad-style() {
    .section {
      padding: .1rem 0 0 .64rem;
    }
  }

  @mixin pc-style() {
    .section {
      padding: .8rem 0 0 2.2rem;
    }
  }

  @media (max-width: 767px) {
    @include phone-style();
    .user-center-content {
      padding-bottom: .4rem;
    }
  }

  @media screen and (min-width: 768px) and (max-width: 991px) {
    @include pad-style();
  }

  @media screen and (min-width: 992px) {
    @include pc-style();
  }
</style>



// WEBPACK FOOTER //
// IndexMain.vue?5698497d